module.exports = __webpack_public_path__ + "static/media/brand.1922b68a.svg";